@if (alerts().length > 0) {
  <div class="notification-container">
    @for (alert of alerts(); track alert.id) {
      <div class="alert" [class.alert-success]="alert.type === 'success'"
                         [class.alert-error]="alert.type === 'error'"
                         [class.alert-info]="alert.type === 'info'"
                         [class.alert-warning]="alert.type === 'warning'">
        <span>{{ alert.message }}</span>
        <button class="alert-close" (click)="dismiss(alert.id)">×</button>
      </div>
    }
  </div>
}
